var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVejleder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D6DFF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C15.038 8 11 12.037 11 17V18H15.424C16.197 19.763 17.955 21 20 21C22.045 21 23.803 19.763 24.576 18H29V17C29 12.037 24.962 8 20 8ZM23 16C23 17.654 21.654 19 20 19C18.346 19 17 17.654 17 16V15.733C18.362 15.219 19.359 14.354 20 13.648C20.641 14.354 21.638 15.219 23 15.733V16ZM25 16V15C25 14.541 24.688 14.142 24.243 14.029C22.044 13.479 20.878 11.519 20.868 11.504C20.512 10.881 19.488 10.881 19.132 11.504C19.121 11.524 17.948 13.483 15.757 14.029C15.312 14.142 15 14.541 15 15V16H13.071C13.558 12.612 16.479 10 20 10C23.521 10 26.442 12.612 26.929 16H25Z",
    fill: "#213E82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H21V28H19V30H21V32H23V30H25V28H23V26Z",
    fill: "#213E82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22C15.29 22 12 24.467 12 28V32H18V30H14V28C14 25.645 16.467 24 20 24C23.533 24 26 25.645 26 28V32H28V28C28 24.467 24.71 22 20 22Z",
    fill: "#213E82"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVejleder);
export default __webpack_public_path__ + "static/media/vejleder.c7ff84ad09c4360cc678c4ded09c5e77.svg";
export { ForwardRef as ReactComponent };